<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-form @submit.prevent="saveItem">
          <b-row>
            <b-col cols="12" class="mb-3">
              <b-button variant="primary" @click="$router.go(-1)" class="pull-left">Terug</b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-tabs>
                <b-tab title="Basisgegevens" active>
                  <b-row>
                    <b-col cols="12" md="12">
                      <b-row>
                        <b-col cols="12" md="6">
                          <b-form-group label="Naam">
                            <b-form-input type="text" required v-model="item.name" :disabled="!editable"></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="6" md="6">
                          <b-form-group label="Chili Publish Item ID">
                            <b-form-input type="text" required v-model="item.chili_item_id" :disabled="!editable"></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="6" md="6">
                          <b-form-group label="Chili Workspace ID">
                            <b-form-input type="text" required v-model="item.chili_workspace_id" :disabled="!editable"></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="12" md="6">
                          <b-form-group label="Info">
                            <ckeditor v-model="item.description" :editor="editor" :config="editorConfig" :disabled="!editable"></ckeditor>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="3" md="3">
                          <b-form-group label="Categorie">
                            <b-form-select v-model="item.chili_category_id" :options="categoryOptions" :disabled="!editable" required></b-form-select>
                          </b-form-group>
                        </b-col>
                        <b-col cols="3" md="3">
                          <b-form-group label="Type">
                            <b-form-select v-model="item.type" :options="typeOptions" :disabled="!editable" required></b-form-select>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <b-form-group label="Foto">
                            <p v-if="current_featured_image"><img :alt="current_featured_image.name" :src="current_featured_image.url" class="img img-thumbnail" width="100"><br>
                              <a href="#" v-if="editable" @click.prevent="clearFeaturedImage">Verwijder afbeelding</a></p>
                            <b-form-file v-else v-model="featuredImageFile" :disabled="saveButtonDisabled || !editable" placeholder="Selecteer een bestand..."></b-form-file>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <hr>
                          <div v-if="editable">
                          <b-button @click.prevent="cancelEdit" class="mr-3" variant="warning">Annuleren</b-button>
                            <b-button type="submit" variant="success" class="pull-right" :disabled="saveButtonDisabled">Wijzigingen opslaan</b-button>
                          </div>
                          <div v-if="!editable">
                          <b-button type="button" @click.prevent="editable = true" variant="primary" class="pull-right">Bewerken</b-button>
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import { updateData, getData } from '../../api';
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  name: 'chili-template',

  components: {
    ClassicEditor
  },

  data() {
    return {
      saveButtonDisabled: false,
      editable: false,
      item: {},
      featuredImageFile: null,

      categoryOptions: [],


      typeOptions: [
        {text: 'Poster', value: 'poster'},
        {text: 'Flyer', value: 'flyer'},
        {text: 'Socials', value: 'socials'},
        {text: 'Website', value: 'website'},
        {text: 'Materiaal', value: 'items'},
        {text: 'Promotie', value: 'promotion'},
        {text: 'Overige', value: 'other'},
      ],

      editor: ClassicEditor,

      editorConfig: {
        toolbar:  ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'insertTable'],
        table: {
          contentToolbar: [
            'tableColumn',
            'tableRow',
            'mergeTableCells'
          ]
        },
        heading: {
          options: [
            { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
            { model: 'heading2', view: 'h2', title: 'Heading 2'},
            { model: 'heading3', view: 'h3', title: 'Heading 3'},
            { model: 'heading4', view: 'h4', title: 'Heading 4'},
          ]
        }
      }
    };
  },

  methods: {
    async refresh() {
      await this.getItem();
    },

    async getItem() {
      this.item = await getData('chili-templates/' + this.$route.params.id).then(
        (response) => response.data.data
      );
    },

    async saveItem() {
      this.saveButtonDisabled = true;

      let formData = new FormData();
      Object.keys(this.item).forEach(key => {
        formData.append(key, this.item[key]);
      });

      const request = await updateData('chili-templates/' + this.$route.params.id, formData);

      if (request.status === 200) {
        this.editable = false;
        this.saveButtonDisabled = false;
        await this.getItem();
      } else {
        this.editable = true;
        this.saveButtonDisabled = false;
      }
    },
    async getCategoryOptions() {
      this.categoryOptions = await getData('chili-templates/categories').then(
        (response) => response.data
      );
    },
    cancelEdit() {
      this.editable = false;
      this.getItem();
    },
    clearFeaturedImage() {
      this.item.featured_image = '';
      this.item.new_featured_image = '';
    },
  },

  computed: {
    userRole: function() {
      return this.$store.state.userRole;
    },
    current_featured_image () {
      return this.item && this.item.featured_image;
    }
  },

  watch: {
    'featuredImageFile'(newValue) {
      this.item.new_featured_image = newValue;
    }
  },
  beforeMount() {
    this.getItem();
    this.getCategoryOptions();

  },
};
</script>

<style>
.ck-editor__editable_inline {
  min-height: 200px;
}
</style>
